import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";

export type Tab<T> = {
    key: T;
    content: React.ReactNode;
    tabId: string;
    panelId: string;
};

type Props<T> = {
    tabs: Array<Tab<T>>;
    selectedTab: T;
};

export default function TabContents<T extends string>({
    tabs,
    selectedTab,
}: Props<T>): React.ReactElement {
    const visitedTabsRef = React.useRef(new Set<T>());
    visitedTabsRef.current.add(selectedTab);

    return (
        <>
            {tabs.map((tab) => (
                <View
                    key={tab.key}
                    id={tab.panelId}
                    aria-labelledby={tab.tabId}
                    style={[
                        styles.tabPanel,
                        tab.key !== selectedTab && styles.hidden,
                    ]}
                >
                    {
                        // render the content for any tab we have already visited.
                        // this way, we don't mount any tabs that we don't visit,
                        // but we don't remount tabs that we visit multiple times.
                        visitedTabsRef.current.has(tab.key) && tab.content
                    }
                </View>
            ))}
        </>
    );
}

const styles = StyleSheet.create({
    tabPanel: {
        flexGrow: 1,
        marginTop: 1,
    },

    hidden: {
        display: "none",
    },
});
